import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["aria-label", "aria-expanded"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-symbols-outlined live-chat-launcher__icon",
  "aria-hidden": "true"
}, " chat ", -1)
const _hoisted_3 = [
  _hoisted_2
]

import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import {
  bootstrapFreshchatAfterConsent,
  hasLiveChatConsent,
  initFreshchatCustomLauncher,
  isFreshchatAvailable,
  isLiveChatFeatureEnabled,
  openFreshchat,
} from "@/utils/freshchat";


export default /*#__PURE__*/_defineComponent({
  __name: 'LiveChatLauncher',
  setup(__props) {

const { t } = useI18n();
const isOpen = ref(false);
const widgetReady = ref(isFreshchatAvailable());
const consentGranted = ref(hasLiveChatConsent());

const visible = computed(
  () => isLiveChatFeatureEnabled() && consentGranted.value && widgetReady.value,
);

let stopHideLauncher: (() => void) | undefined;
let pollId: number | undefined;
let consentPollId: number | undefined;

const refreshConsent = () => {
  const nextConsent = hasLiveChatConsent();
  consentGranted.value = nextConsent;
  if (nextConsent) {
    bootstrapFreshchatAfterConsent();
  }
};

const refreshWidgetReady = () => {
  if (isFreshchatAvailable()) {
    widgetReady.value = true;
    if (pollId !== undefined) {
      window.clearInterval(pollId);
      pollId = undefined;
    }
  }
};

const handleClick = () => {
  if (openFreshchat()) {
    isOpen.value = true;
  }
};

const onWindowFocus = () => {
  refreshConsent();
  refreshWidgetReady();
};

onMounted(() => {
  refreshConsent();
  refreshWidgetReady();
  stopHideLauncher = initFreshchatCustomLauncher();

  pollId = window.setInterval(refreshWidgetReady, 500);
  consentPollId = window.setInterval(refreshConsent, 1500);
  window.addEventListener("focus", onWindowFocus);
});

onBeforeUnmount(() => {
  stopHideLauncher?.();
  if (pollId !== undefined) window.clearInterval(pollId);
  if (consentPollId !== undefined) window.clearInterval(consentPollId);
  window.removeEventListener("focus", onWindowFocus);
});

return (_ctx: any,_cache: any) => {
  return (_unref(visible))
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: "live-chat-launcher",
        "aria-label": _unref(t)('message.LIVE_CHAT_OPEN_LABEL'),
        "aria-expanded": isOpen.value,
        onClick: handleClick
      }, _hoisted_3, 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})